// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardSection_mainSection__Ci2Vh {
  margin: 4rem 0 0;
}

.cardSection_cards__iVn3G {
  display: flex;
  justify-content: space-between;
}

.cardSection_card_section__0WC0f {
  width: 100%;

  & img {
    width: 100%;
    height: auto;
  }
}

.cardSection_userGrid__UaB7D {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 50px;
  margin-bottom: 6rem;
}

.cardSection_userImage__U99U0 {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
}

.cardSection_userName__aoeCR {
  padding: 5px 0;
  font-family: Inter;
  font-size: 1.1rem;
  font-weight: 700;
}

.cardSection_userDescription__XzIz4 {
  font-family: Inter;
  font-size: 0.9rem;
  font-weight: 500;
}

@media (max-width: 768px) {
  .cardSection_userGrid__UaB7D {
    margin: 2rem 0;
    grid-template-columns: repeat(2, 1fr);
  }

  br {
    display: none;
  }
}

@media (max-width: 480px) {
  .cardSection_userGrid__UaB7D {
    grid-template-columns: 1fr; /* 1 card in a row for very small screens */
  }

  br {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/CardSection/cardSection.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;;EAEX;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;IACd,qCAAqC;EACvC;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B,EAAE,2CAA2C;EACzE;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".mainSection {\n  margin: 4rem 0 0;\n}\n\n.cards {\n  display: flex;\n  justify-content: space-between;\n}\n\n.card_section {\n  width: 100%;\n\n  & img {\n    width: 100%;\n    height: auto;\n  }\n}\n\n.userGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 50px;\n  margin-bottom: 6rem;\n}\n\n.userImage {\n  width: 100%;\n  height: auto;\n  margin-bottom: 10px;\n}\n\n.userName {\n  padding: 5px 0;\n  font-family: Inter;\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n.userDescription {\n  font-family: Inter;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n@media (max-width: 768px) {\n  .userGrid {\n    margin: 2rem 0;\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  br {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .userGrid {\n    grid-template-columns: 1fr; /* 1 card in a row for very small screens */\n  }\n\n  br {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainSection": `cardSection_mainSection__Ci2Vh`,
	"cards": `cardSection_cards__iVn3G`,
	"card_section": `cardSection_card_section__0WC0f`,
	"userGrid": `cardSection_userGrid__UaB7D`,
	"userImage": `cardSection_userImage__U99U0`,
	"userName": `cardSection_userName__aoeCR`,
	"userDescription": `cardSection_userDescription__XzIz4`
};
export default ___CSS_LOADER_EXPORT___;
